import React from "react";
import { Route, Routes } from "react-router-dom";
import NotFound from "../utils/NotFound";
import MerchantList from "../components/storeadmin/merchant";
import MerchantDetails from "../components/storeadmin/merchant/details";

const StoreAdminRoute = () => {
  return (
    <Routes>
      <Route hidden path="/" element={<MerchantList />} />
      <Route
        hidden
        path="/:user_id/:merchant_name"
        element={<MerchantDetails />}
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default StoreAdminRoute;
